export default "__VITE_ASSET__BdMG_mMy__"